/*
 * cluutch-charly-cadeau.js
 * Hôtel Charly : le cadeau offert dès 3 articles de la collection. Mail de Zineb du 23/10/2026 : « Pour le
 * porte-clé, il est offert à l'achat de 3 produits et plus de la collection Hôtel Charly. » Décisions
 * d'Hicham (23/10) : 3 articles en tout (quantités additionnées, un vanity compte pour 1), un seul cadeau
 * par commande. Le produit, le seuil et l'affichage viennent de snippets/cluutch-charly-cadeau.liquid, qui
 * pose ce script avec ses données (data-variante, data-seuil, data-dispo, data-message).
 *
 * Choix structurants :
 * - le cadeau reste à 0 €, sans remise : le plan Shopify de la boutique n'a pas de contrôle côté serveur,
 *   et une seule remise « achetez X, obtenez Y » s'applique par panier, déjà prise par les coffrets ;
 * - même patron que cluutch-charly-limites.js : le script enveloppe fetch pour /cart/add, /cart/change et
 *   /cart/update, et rien d'autre. Chargé juste après lui (layout/theme.liquid), il enveloppe SON fetch : il
 *   voit le panier déjà ramené à la limite des vanitys, et ses propres écritures passent par elle ;
 * - seuil atteint et cadeau disponible : il entre au panier ; sous le seuil ou épuisé : il repart ; en
 *   double : ramené à 1. Une seule requête, /cart/update.js en quantités absolues (rejouée après une
 *   erreur, elle ne peut pas en ajouter un second), avec les sections que le thème a demandées : le thème
 *   reçoit une réponse déjà juste, et ne rend qu'une fois ;
 * - AUCUNE lecture de /cart.js à l'ajout : le tiroir (ou la page panier) rendu dans la réponse porte les
 *   marqueurs data-charly-article et data-charly-cadeau ; change et update renvoient le panier entier.
 *   /cart.js n'est lu qu'en repli (ajout sans sections), avec reprises : le défi anti-robot de la vitrine
 *   répond 429 quand on enchaîne les requêtes (constaté le 08/10) ;
 * - un ajout sans article Charly ni cadeau passe tel quel, sans calcul. Une erreur ici rend la réponse
 *   d'origine : le panier ne casse jamais à cause de ce script ;
 * - <cluutch-charly-etapes>, la jauge à crans de la fiche, se recompte à chaque nouveau rendu du tiroir,
 *   sans requête.
 * Limites assumées (comme pour les limites Charly du 08/10) : un lien de panier direct ou le paiement
 * express d'une fiche passent outre le site ; un panier déjà au seuil sans cadeau (stock revenu entre-temps)
 * le reçoit au changement suivant.
 * Auteur : Cluutch / Studio Hogo.
 */
(function () {
	if (window.cluutchCharlyCadeauReady) return;
	window.cluutchCharlyCadeauReady = true;

	var script = document.currentScript;
	var VARIANTE = script ? Number(script.dataset.variante) : 0;
	if (!VARIANTE) return;
	var SEUIL = Number(script.dataset.seuil) || 3;
	var DISPO = script.dataset.dispo === 'true';
	var MESSAGE = script.dataset.message || '';
	var fetchOrigine = window.fetch;
	var CIBLE = /\/cart\/(add|change|update)(?:\.js)?\/?(?:[?#]|$)/;
	// Les messages entrent aux places de ceux des limites : en tête de la liste du tiroir, sous le titre
	// de la page panier.
	var HOTES = {
		'cart-drawer': { selecteur: '.product-cart-item--container', place: 'prepend' },
		'main-cart': { selecteur: '.thb-cart-form h4', place: 'after' }
	};
	// Où compter dans une section rendue : la liste du tiroir, sinon le tableau de la page panier. Ni l'une
	// ni l'autre : panier vide, ou section absente de la réponse.
	var LISTES = [['cart-drawer', '.product-cart-item--container'], ['main-cart', '.cart-items']];
	// Le style exact du message des limites Charly (cluutch-charly-limites.js), retenu sur maquette le 23/10.
	var STYLE = 'margin: 0 0 12px; padding: 12px 14px; font-size: 14px; font-weight: 500; line-height: 1.4; color: #1a1a1a; background: #f4f4f4; border-left: 3px solid #4e1e25; border-radius: 0 4px 4px 0;';

	function route(nom, defaut) {
		return (window.theme && window.theme.routes && window.theme.routes[nom]) || defaut;
	}

	function estCadeau(ligne) {
		return Number(ligne.variant_id) === VARIANTE;
	}

	function estCharly(ligne) {
		return typeof ligne.sku === 'string' && ligne.sku.indexOf('CH-') === 0 && !estCadeau(ligne);
	}

	// L'état d'un panier JSON (réponse de change ou d'update, /cart.js) : les articles comptés, les lignes du cadeau.
	function etatDuPanier(items) {
		var etat = { articles: 0, cadeaux: [] };
		items.forEach(function (l) {
			if (estCadeau(l)) etat.cadeaux.push({ key: l.key, quantity: l.quantity });
			else if (estCharly(l)) etat.articles += l.quantity;
		});
		return etat;
	}

	// Le même état, lu dans le HTML du panier (cart-drawer.liquid, main-cart.liquid, cluutch-charly-cadeau.liquid).
	function etatDuRendu(racine) {
		var etat = { articles: 0, cadeaux: [] };
		racine.querySelectorAll('[data-charly-article]').forEach(function (el) {
			etat.articles += parseInt(el.getAttribute('data-charly-article'), 10) || 0;
		});
		racine.querySelectorAll('[data-charly-cadeau]').forEach(function (el) {
			etat.cadeaux.push({
				key: el.getAttribute('data-charly-cadeau'),
				quantity: parseInt(el.getAttribute('data-charly-cadeau-quantite'), 10) || 1
			});
		});
		return etat;
	}

	function etatDesSections(sections) {
		if (!sections) return null;
		for (var i = 0; i < LISTES.length; i++) {
			var html = sections[LISTES[i][0]];
			if (!html) continue;
			var liste = new DOMParser().parseFromString(html, 'text/html').querySelector(LISTES[i][1]);
			if (liste) return etatDuRendu(liste);
		}
		return null;
	}

	// Les quantités à écrire ({ clé de ligne, ou variante pour l'ajouter : quantité }), ou null si le panier
	// est juste. `entre` : le cadeau arrive, on l'annonce.
	function corrections(etat) {
		var vise = etat.articles >= SEUIL && DISPO ? 1 : 0;
		var updates = {};
		etat.cadeaux.forEach(function (c, i) {
			var q = i === 0 ? vise : 0;
			if (c.quantity !== q) updates[c.key] = q;
		});
		if (vise && !etat.cadeaux.length) updates[VARIANTE] = 1;
		if (!Object.keys(updates).length) return null;
		return { updates: updates, entre: vise === 1 && !etat.cadeaux.length };
	}

	function lireJson(reponse) {
		if (!reponse.ok) throw new Error('cluutch-charly-cadeau : ' + reponse.status + ' ' + reponse.url);
		return reponse.json();
	}

	// Une requête avec reprises espacées (429 du défi anti-robot, réseau).
	function avecReprises(faire, delais) {
		return faire().catch(function (e) {
			if (!delais.length) throw e;
			return new Promise(function (ok) { setTimeout(ok, delais[0]); })
				.then(function () { return avecReprises(faire, delais.slice(1)); });
		});
	}

	function lirePanier() {
		return avecReprises(function () {
			return fetchOrigine.call(window, route('cart_url', '/cart') + '.js', {
				cache: 'no-store',
				headers: { Accept: 'application/json' }
			}).then(lireJson);
		}, [700, 1600]);
	}

	function corriger(updates, sections) {
		var corps = { updates: updates };
		if (sections.length) {
			corps.sections = sections.join(',');
			corps.sections_url = window.location.pathname;
		}
		return avecReprises(function () {
			return fetchOrigine.call(window, route('cart_update_url', '/cart/update') + '.js', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify(corps)
			}).then(lireJson);
		}, [1000]);
	}

	// Les sections du nouveau rendu, avec le message du cadeau s'il vient d'entrer. Les messages des limites
	// déjà posés dans les sections d'origine (un vanity refusé dans le même ajout) y sont repris : le nouveau
	// rendu les aurait effacés.
	function baliser(sections, anciennes, message) {
		Object.keys(HOTES).forEach(function (id) {
			if (!sections[id]) return;
			var doc = new DOMParser().parseFromString(sections[id], 'text/html');
			var hote = doc.querySelector(HOTES[id].selecteur);
			if (!hote) return;
			var poses = [];
			if (anciennes && anciennes[id]) {
				new DOMParser().parseFromString(anciennes[id], 'text/html')
					.querySelectorAll('.cluutch-charly-limite')
					.forEach(function (m) { poses.push(doc.importNode(m, true)); });
			}
			if (message) {
				var p = doc.createElement('p');
				p.className = 'cluutch-charly-cadeau-message';
				p.setAttribute('role', 'status');
				p.setAttribute('style', STYLE);
				p.textContent = message;
				poses.push(p);
			}
			if (!poses.length) return;
			hote[HOTES[id].place].apply(hote, poses);
			sections[id] = doc.body.innerHTML;
		});
		return sections;
	}

	// La réponse corrigée, ou null si le panier est juste.
	function verifier(type, donnees) {
		var sections = donnees.sections ? Object.keys(donnees.sections) : [];
		var etat;
		if (type === 'add') {
			var ajoutees = donnees.items || [donnees];
			if (!ajoutees.some(function (l) { return estCharly(l) || estCadeau(l); })) return null;
			var lu = etatDesSections(donnees.sections);
			etat = lu ? Promise.resolve(lu) : lirePanier().then(function (p) { return etatDuPanier(p.items); });
		} else {
			if (!donnees.items) return null;
			etat = Promise.resolve(etatDuPanier(donnees.items));
		}
		return etat.then(function (e) {
			var c = corrections(e);
			if (!c) return null;
			return corriger(c.updates, sections).then(function (corrige) {
				var retour = type === 'add' ? donnees : corrige;
				if (sections.length) retour.sections = baliser(corrige.sections || {}, donnees.sections, c.entre ? MESSAGE : '');
				return new Response(JSON.stringify(retour), {
					status: 200,
					headers: { 'Content-Type': 'application/json' }
				});
			});
		});
	}

	window.fetch = function (ressource, init) {
		var appel = fetchOrigine.apply(window, arguments);
		var url = String((ressource && ressource.url) || ressource || '');
		var methode = String((init && init.method) || (ressource && ressource.method) || 'GET').toUpperCase();
		var cible = CIBLE.exec(url);
		if (!cible || methode !== 'POST') return appel;
		return appel.then(function (reponse) {
			if (!reponse.ok) return reponse;
			return reponse.clone().json()
				.then(function (donnees) { return verifier(cible[1], donnees); })
				.then(function (corrigee) { return corrigee || reponse; })
				.catch(function (e) {
					console.error('cluutch-charly-cadeau', e);
					return reponse;
				});
		});
	};

	// La jauge à crans de la fiche (vue `etapes`) : rendue par Liquid, puis recomptée dans le tiroir à chaque
	// nouveau rendu (le thème remplace ses enfants : ajout, quantité, ligne retirée, « Tout supprimer », code
	// promo), comme le moteur de la fiche le fait pour la jauge en euros. Aucune requête.
	class CluutchCharlyEtapes extends HTMLElement {
		connectedCallback() {
			this.tiroir = document.getElementById('Cart-Drawer');
			if (!this.tiroir || this.observateur) return;
			this.observateur = new MutationObserver(this.recompter.bind(this));
			this.observateur.observe(this.tiroir, { childList: true });
		}

		disconnectedCallback() {
			if (this.observateur) this.observateur.disconnect();
			this.observateur = null;
		}

		recompter() {
			var etat = etatDuRendu(this.tiroir);
			var crans = this.querySelectorAll('[data-charly-etapes-cran]');
			var seuil = crans.length;
			var n = etat.articles;
			var cas;
			if (n >= seuil) cas = etat.cadeaux.length ? 'Offert' : '';
			else if (n === seuil - 1) cas = 'Dernier';
			else cas = n > 0 ? 'Reste' : 'Des';
			this.hidden = !cas;
			if (!cas) return;
			this.classList.toggle('est-acquis', cas === 'Offert');
			crans.forEach(function (c, i) {
				c.classList.toggle('est-plein', i < n);
				c.classList.toggle('est-prochain', cas === 'Dernier' && i === n);
			});
			var texte = this.querySelector('[data-charly-etapes-texte]');
			if (texte) texte.textContent = (this.dataset['texte' + cas] || '').replace('[nombre]', seuil - n);
		}
	}

	if (!customElements.get('cluutch-charly-etapes')) customElements.define('cluutch-charly-etapes', CluutchCharlyEtapes);
})();
